import { pushWithQuery } from '../../utils';
import { paths } from '../../paths';
import { SOMETHING_WENT_WRONG_ERROR } from './constants';

export const SEND_PHONE_NUMBER_SUCCESS =
    '@@phoneentry/SEND_PHONE_NUMBER_SUCCESS';
export const SEND_PHONE_NUMBER_FAILURE =
    '@@phoneentry/SEND_PHONE_NUMBER_FAILURE';
export const SEND_PHONE_NUMBER = '@@phoneentry/SEND_PHONE_NUMBER';
export const CHANGE_PHONE_NUMBER = '@@phoneentry/CHANGE_PHONE_NUMBER';

export const changePhoneNumber = phoneNumber => ({
    type: CHANGE_PHONE_NUMBER,
    phoneNumber,
});

export function sendPhoneNumber() {
    return {
        type: SEND_PHONE_NUMBER,
    };
}

export function sendPhoneNumberSuccess() {
    return {
        type: SEND_PHONE_NUMBER_SUCCESS,
    };
}

export function sendPhoneNumberFailure(error) {
    return {
        type: SEND_PHONE_NUMBER_FAILURE,
        error,
    };
}

const apiHost = process.env.API_HOST || '';
const endpoint = `${apiHost}/api/web/2/phone/unverifiedphone`;

export function sendPhoneNumberStart(phoneNumber, bookingId) {
    return dispatch => {
        dispatch(sendPhoneNumber());

        const fetchData = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                phone_number: phoneNumber,
            }),
            credentials: 'include',
        };

        let responseStatus;

        return fetch(endpoint, fetchData)
            .then(response => {
                responseStatus = response.status;

                if (responseStatus === 204) {
                    dispatch(sendPhoneNumberSuccess());
                    dispatch(
                        pushWithQuery(
                            `${paths.appointmentDetailsPath}/${bookingId}`
                        )
                    );
                } else {
                    return response.json().then(body => {
                        if (body.error) {
                            dispatch(
                                sendPhoneNumberFailure(
                                    body.error.fields[0].message
                                )
                            );
                        } else {
                            dispatch(
                                sendPhoneNumberFailure(
                                    SOMETHING_WENT_WRONG_ERROR
                                )
                            );
                        }
                    });
                }
            })
            .catch(error => {
                if (error.error) {
                    dispatch(
                        sendPhoneNumberFailure(error.error.fields[0].message)
                    );
                } else {
                    dispatch(
                        sendPhoneNumberFailure(SOMETHING_WENT_WRONG_ERROR)
                    );
                }
            });
    };
}
